import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, TextField } from '@mui/material'
import { SettingsBondPolicyDto, settingsBondPolicyValidationSchema } from 'dtos'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'

interface BondPolicyAddEditDialogProps {
  initialValues: SettingsBondPolicyDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function BondPolicyAddEditDialog({
  initialValues,
  isLoading,
  onClose,
  onSave,
  open
}: BondPolicyAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={false}
        validationSchema={settingsBondPolicyValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Bond Policy</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(touched.bondThreshold && errors.bondThreshold)}
                      helperText={(touched.bondThreshold && errors.bondThreshold) || 'Enter the Bond Threshold amount in USD'}
                      InputProps={{
                        startAdornment: <InputAdornment position='start'>$</InputAdornment>
                      }}
                      label='Bond Threshold'
                      name='bondThreshold'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.bondThreshold}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(
                        touched.bondBlockQuantityAlertNotificationEmail && errors.bondBlockQuantityAlertNotificationEmail
                      )}
                      helperText={
                        (touched.bondBlockQuantityAlertNotificationEmail && errors.bondBlockQuantityAlertNotificationEmail) ||
                        'Enter the Bond Block Quantity Alert Notification Email'
                      }
                      label='Bond Block Quantity'
                      name='bondBlockQuantityAlertNotificationEmail'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.bondBlockQuantityAlertNotificationEmail}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion variant='outlined'>||All fields are required. ||</ExplanationAccordion>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading || isSubmitting} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton color='primary' loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
